import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (refresh) {
  const { isRequestSuccessed, data, exec } = useRequest({
    url: '/api/Work/shop/position',
    name: 'locationInforGet',
    method: 'GET'
  });
  useEffect(() => {
    if (refresh) {
      exec({ url: '/api/Work/shop/position' })
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);
  return [isRequestSuccessed, data || [], exec];
})
